/**
 * Card Interaction Tracker
 * Tracks user interactions with party/team cards (clicks on socials, copy riot id)
 */

import { csrfToken } from '../utils/http';
import { on } from '../utils/events';

const API_ENDPOINT = '/api/interactions';

/**
 * Track an interaction with a card
 * Uses sendBeacon for reliable delivery even when navigating away
 * @param {HTMLElement} element - The clicked element (should be inside a card)
 * @param {string} actionType - Type of action (click_discord, click_instagram, etc.)
 */
export function trackInteraction(element, actionType) {
    const card = element.closest('[data-entity-type]');
    if (!card) return;

    const entityType = card.dataset.entityType;
    const entityId = card.dataset.entityId;

    if (!entityType || !entityId) return;

    const data = {
        entity_type: entityType,
        entity_id: entityId,
        action_type: actionType,
        _token: csrfToken || '',
    };

    // sendBeacon guarantees delivery even when navigating away
    if (navigator.sendBeacon) {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        navigator.sendBeacon(API_ENDPOINT, formData);
    } else {
        // Fallback for older browsers
        fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': data._token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true,
        }).catch(() => {});
    }
}

/**
 * Initialize tracking for social link clicks
 */
export function initSocialTracking() {
    on('click', 'a[href*="instagram.com"]:not(.disabled)', (e, link) => trackInteraction(link, 'click_instagram'));
    on('click', 'a[href*="t.me"]:not(.disabled)', (e, link) => trackInteraction(link, 'click_telegram'));
}
